// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
}

.wrapper {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 50px 30px 20px;
}
.wrapper .header {
  text-align: center;
  margin-bottom: 24px;
  position: relative;
}
.wrapper .header .close-icon {
  position: absolute;
  top: -30px;
  right: -40px;
  font-size: 20px;
  color: #666;
  cursor: pointer;
  z-index: 10;
}
.wrapper .header .close-icon:hover {
  color: #000;
}
.wrapper .header .title {
  font-size: 45px;
  font-weight: 700;
  text-transform: uppercase;
  margin: 0;
}
.wrapper .header .subtitle {
  font-size: 14px;
  color: #000;
  margin: 4px 0 0;
}
.wrapper .content {
  flex-grow: 1;
  overflow: auto;
  padding-inline: 5px;
  padding-top: 10px;
}
.wrapper .content .article-wrapper {
  display: grid;
  align-items: stretch;
  grid-template-columns: repeat(2, 1fr);
  gap: 16px;
  width: 100%;
  margin-bottom: 24px;
}
.wrapper .footer {
  width: 100%;
  padding-top: 10px;
  margin-top: auto;
}
.wrapper .footer ion-button {
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/app/components/extra-option-modal/extra-option-modal.component.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;AACD;;AAEA;EACC,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;AACD;AACC;EACC,kBAAA;EACA,mBAAA;EACA,kBAAA;AACF;AACE;EACC,kBAAA;EACA,UAAA;EACA,YAAA;EACA,eAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AACH;AACG;EACC,WAAA;AACJ;AAGE;EACC,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,SAAA;AADH;AAIE;EACC,eAAA;EACA,WAAA;EACA,eAAA;AAFH;AAMC;EACC,YAAA;EACA,cAAA;EACA,mBAAA;EACA,iBAAA;AAJF;AAME;EACC,aAAA;EACA,oBAAA;EACA,qCAAA;EACA,SAAA;EACA,WAAA;EACA,mBAAA;AAJH;AAQC;EACC,WAAA;EACA,iBAAA;EACA,gBAAA;AANF;AAQE;EACC,WAAA;AANH","sourcesContent":[":host {\n\tdisplay: block;\n}\n\n.wrapper {\n\theight: 100%;\n\tdisplay: flex;\n\tflex-direction: column;\n\talign-items: center;\n\tpadding: 50px 30px 20px;\n\n\t.header {\n\t\ttext-align: center;\n\t\tmargin-bottom: 24px;\n\t\tposition: relative;\n\n\t\t.close-icon {\n\t\t\tposition: absolute;\n\t\t\ttop: -30px;\n\t\t\tright: -40px;\n\t\t\tfont-size: 20px;\n\t\t\tcolor: #666;\n\t\t\tcursor: pointer;\n\t\t\tz-index: 10;\n\n\t\t\t&:hover {\n\t\t\t\tcolor: #000;\n\t\t\t}\n\t\t}\n\n\t\t.title {\n\t\t\tfont-size: 45px;\n\t\t\tfont-weight: 700;\n\t\t\ttext-transform: uppercase;\n\t\t\tmargin: 0;\n\t\t}\n\n\t\t.subtitle {\n\t\t\tfont-size: 14px;\n\t\t\tcolor: #000;\n\t\t\tmargin: 4px 0 0;\n\t\t}\n\t}\n\n\t.content {\n\t\tflex-grow: 1;\n\t\toverflow: auto;\n\t\tpadding-inline: 5px;\n\t\tpadding-top: 10px;\n\n\t\t.article-wrapper {\n\t\t\tdisplay: grid;\n\t\t\talign-items: stretch;\n\t\t\tgrid-template-columns: repeat(2, 1fr);\n\t\t\tgap: 16px;\n\t\t\twidth: 100%;\n\t\t\tmargin-bottom: 24px;\n\t\t}\n\t}\n\n\t.footer {\n\t\twidth: 100%;\n\t\tpadding-top: 10px;\n\t\tmargin-top: auto;\n\n\t\tion-button {\n\t\t\twidth: 100%;\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
